import { render } from "./AdminColour.vue?vue&type=template&id=9594ad16"
import script from "./AdminColour.vue?vue&type=script&lang=js"
export * from "./AdminColour.vue?vue&type=script&lang=js"

import "./AdminColour.vue?vue&type=style&index=0&id=9594ad16&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__